export class TelerikImageUploadViewModel {
  public static createEmpty(): TelerikImageUploadViewModel {
    return new TelerikImageUploadViewModel();
  }
  constructor(
    public Id: string = '',
    public File: File | null = null,
    public ImageUrl: string = '',
    public ImageWidth: number = 0,
    public ImageHeight: number = 0,
  ) { }
}
